import backend from '@/helpers/backend';

function versionParam(image: string): string {
  return encodeURIComponent(image);
}

export function getBuildingImageUrl(building: { id: string; municipalityId: string; image?: string | null }): string | undefined {
  if (!building.image) return undefined;
  return `${backend.defaults.baseURL}/municipalities/${building.municipalityId}/buildings/${building.id}/image?v=${versionParam(building.image)}`;
}

export function getBuildingImagePath(building: { id: string; municipalityId: string; image?: string | null }): string | undefined {
  if (!building.image) return undefined;
  return `/municipalities/${building.municipalityId}/buildings/${building.id}/image?v=${versionParam(building.image)}`;
}

export function getBuildingGroupImageUrl(group: { id: string; image?: string | null }, municipalityId?: string | null): string | undefined {
  if (!group.image || !municipalityId) return undefined;
  return `${backend.defaults.baseURL}/building-groups/${group.id}/image?municipalityId=${municipalityId}&v=${versionParam(group.image)}`;
}

export function getMunicipalityImagePath(municipality: { id: string; image?: string | null }): string | undefined {
  if (!municipality.image) return undefined;
  return `/municipalities/${municipality.id}/image?v=${versionParam(municipality.image)}`;
}
